import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'ui';

type HeaderCloseButtonProps = {
  onClick: () => void;
};

function HeaderCloseButton({ onClick }: HeaderCloseButtonProps): JSX.Element {
  const { t } = useTranslation();

  return <Button ariaLabel={t('actions:Close')} className="header-close-button" iconSize="xl" isIconOnly leftIcon="close" onClick={onClick} variant="plain" />;
}

export default HeaderCloseButton;
